import { api, fileApi } from '../../services/api';
import { AccountingFile, ObligationFile, SendFeedbackParams } from './types';

export const changeFilePaymentStatus = async (
  id: number,
  isPaid: boolean
): Promise<ObligationFile> => {
  const response = await api.patch(
    `/customer/file/${id}/status/${isPaid ? 'Pago' : 'Pendente'}`
  );
  return response.data.data;
};

export const downloadFile = async (id: number) => {
  const response = await fileApi.patch<Blob>(`/customer/file/${id}`, null, {
    responseType: 'blob',
  });
  return response.data;
};

export const markFileAsViewed = async (id: number) => {
  const response = await api.patch(`/customer/file/${id}/mark-viewed`);
  return response.data;
};

export const getFilesByYearAndMonth = async (
  date: string
): Promise<ObligationFile[]> => {
  console.log('[Calendário de Obrigações] Request:', {
    endpoint: `/customer/files?date=${date}`,
    date,
  });
  const response = await api.get(`/customer/files?date=${date}`);
  console.log('[Calendário de Obrigações] Response:', {
    status: response.status,
    data: response.data,
  });
  return response.data.data;
};

export const getAllFiles = async (): Promise<AccountingFile[]> => {
  const response = await api.get(`/customer/files`);
  return response.data.data;
};

export const sendFeedback = async ({
  appUserId,
  rating,
  metaInfo,
  description,
}: SendFeedbackParams) => {
  await api.post('/feedbacks', {
    appUserId,
    rating,
    metaInfo,
    description,
  });
};
